import { Injectable, OnInit } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';


@Injectable()
export class StateService {

  private editable = new BehaviorSubject<boolean>(false);

  constructor() {}

/**
 * Gibt ein Observable mit dem Editable-Status zurück
 *
 * @returns Observable
 */
  public getEditableState(): Observable<boolean> {
    return this.editable.asObservable();
  }

  /**
   * Der neue Status ob die Ansicht bearbeitet werden darf oder nicht
   *
   * @param boolean
   */
  public setEditableState = (newState: boolean) => {
    this.editable.next(newState);
  }

}
